import { useHistory } from 'react-router'
import { ReauthenticationVariant } from 'shared/types'
import {
  exitSystemAdminMode,
  getReauthenticationSuccessPath,
  isSystemAdminMode,
} from 'shared/utils'

// Reauthentication ends the system admin mode
export const useRedirectToReauthenticationSuccess = () => {
  const history = useHistory()

  return (variant: ReauthenticationVariant) => {
    const successPath = getReauthenticationSuccessPath(variant)

    if (isSystemAdminMode()) {
      exitSystemAdminMode(successPath)
    } else {
      history.push(successPath)
    }
  }
}
